import script from "./PopupBody.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupBody.vue?vue&type=script&setup=true&lang=js"

import "./PopupBody.vue?vue&type=style&index=0&id=3ea913ad&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ea913ad"]])

export default __exports__